import axios from "axios";

export const AUDIT_URL = "/api/audit-documents/signed";
const {REACT_APP_API_URL} = process.env;

export function downloadAudit(signedDocumentId) {
    //https://stackoverflow.com/questions/60454048/how-does-axios-handle-blob-vs-arraybuffer-as-responsetype
    return axios.get(`${REACT_APP_API_URL}${AUDIT_URL}/${signedDocumentId}/download`, {responseType: 'arraybuffer'});//responseType: 'blob'
}
